// extracted by mini-css-extract-plugin
export var buttons = "top-collections-module--buttons--9edda";
export var scrollbar = "top-collections-module--scrollbar--8ed96";
export var scrolldrag = "top-collections-module--scrolldrag--23fec";
export var scroller = "top-collections-module--scroller--087c9";
export var section = "top-collections-module--section--a02c8";
export var slide = "top-collections-module--slide--15619";
export var slider = "top-collections-module--slider--e7b8b";
export var title = "top-collections-module--title--a499c";